const Style = {

  container: 'bg-white border border-gray-200 rounded-xl overflow-hidden',
  scroll:    'overflow-x-auto',
  table:     'w-full border-collapse text-sm',
  thead:     'border-b border-gray-200 bg-white',

  // Header cells
  th:          'px-2 py-3 text-left font-semibold text-[12px] text-gray-500 whitespace-nowrap uppercase tracking-[0.05em] select-none',
  thSortable:  'cursor-pointer hover:text-gray-700',
  thStatic:    'cursor-default',
  thLabel:     'inline-flex items-center gap-1',
  sortActive:  'text-gray-700 text-[11px]',
  sortInactive:'text-gray-300 text-[11px]',

  // Body rows & cells
  row:              'border-b border-gray-50 hover:bg-gray-50',
  empty:            'py-10 text-center text-gray-400',
  cellDate:         'px-2 py-3 whitespace-nowrap w-[122px]',
  dateMain:         'block text-xs text-gray-900 leading-relaxed',
  dateTime:         'block text-xs text-gray-400 leading-relaxed',
  cellRating:       'px-2 py-3 w-[100px]',
  cellComment:      'px-2 py-3 text-gray-900 leading-relaxed cursor-pointer max-w-[420px]',
  commentText:      'text-sm text-gray-800 line-clamp-4 leading-relaxed',
  commentChip:      'mt-1 inline-flex items-center gap-1 text-[11px] text-blue-600 font-medium',
  cellErrorType:    'px-2 py-3 text-gray-900 w-[140px] whitespace-nowrap',
  cellEmail:        'px-2 py-3 text-gray-900 w-[200px] whitespace-nowrap',
  cellActions:      'px-2 py-3 w-[60px] text-center',
  muted:            'text-gray-400',

  // Chat history modal
  modalOverlay:     'fixed inset-0 z-50 flex items-center justify-center bg-black/40 transition-[left] duration-200',
  modalPanel:       'bg-white rounded-2xl shadow-2xl w-full md:w-[70vw] md:max-w-none mx-4 md:mx-0 max-h-[85vh] flex flex-col',
  modalHeader:      'flex items-center justify-between px-6 py-4 border-b border-gray-100 shrink-0',
  modalTitle:       'text-lg font-semibold text-gray-900',
  modalClose:       'p-1 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer text-lg',
  modalBody:        'overflow-y-auto px-6 py-5 flex flex-col gap-5',
  modalComment:     'bg-gray-50 rounded-xl px-4 py-3 text-base text-gray-800 leading-relaxed border border-gray-200',
  modalCommentLbl:  'text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1.5',
  modalDivider:     'border-t border-gray-100 my-1',
  chatTurn:         'flex flex-col gap-1.5',
  chatRole:         'text-xs font-semibold uppercase tracking-wide',
  chatRoleUser:        'text-blue-600',
  chatRoleAsst:        'text-violet-600',
  practiceAreaBadge:   'inline-block text-[12px] font-medium px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200',
  chatBubble:       'rounded-xl px-4 py-3 leading-relaxed',
  chatBubbleUser:   'bg-blue-50 text-gray-800 text-base',
  chatBubbleAsst:   'bg-violet-50 text-gray-800',

  // Markdown prose styles (used inside assistant bubble)
  mdH1:           'text-xl font-bold text-gray-900 mt-4 mb-1.5',
  mdH2:           'text-lg font-bold text-gray-900 mt-4 mb-1.5',
  mdH3:           'text-base font-semibold text-gray-800 mt-3 mb-1',
  mdP:            'text-base text-gray-800 leading-relaxed mb-2.5 last:mb-0',
  mdUl:           'list-disc list-outside pl-5 mb-2.5 space-y-1',
  mdOl:           'list-decimal list-outside pl-5 mb-2.5 space-y-1',
  mdLi:           'text-base text-gray-800 leading-relaxed',
  mdStrong:       'font-semibold text-gray-900',
  mdEm:           'italic',
  mdHr:           'border-t border-violet-200 my-4',
  mdBlockquote:   'border-l-2 border-violet-300 pl-3 italic text-gray-600 my-2',
  mdCodeInline:   'bg-violet-100 text-violet-800 text-sm rounded px-1.5 py-0.5 font-mono',
  mdPre:          'bg-gray-900 rounded-lg p-3 my-2 overflow-x-auto',
  mdCode:         'text-green-400 text-sm font-mono',
  mdTableWrap:    'overflow-x-auto my-2',
  mdTable:        'w-full border-collapse text-sm',
  mdThead:        'bg-violet-100',
  mdTr:           'border-b border-violet-100',
  mdTh:           'px-3 py-2 text-left font-semibold text-gray-700 whitespace-nowrap',
  mdTd:           'px-3 py-2 text-gray-800 align-top',

  // Rating badge
  badge:       'inline-block rounded-[28px] px-2.5 py-1 text-xs font-normal whitespace-nowrap',

  // Pagination bar
  pagination:     'flex justify-between items-center px-4 py-3 border-t border-gray-100',
  pageSizeGroup:  'flex items-center gap-2 text-sm text-gray-900',
  pageSizeSelect: 'border border-gray-200 rounded-[10px] px-3.5 h-[35px] text-sm text-gray-900 bg-white cursor-pointer',
  pageCtrlGroup:  'flex items-center gap-2 text-sm text-gray-900',
  pageInput:      'w-[50px] h-[35px] border border-gray-200 rounded-[10px] text-sm text-center box-border',
  pageBtn:        'bg-white border border-gray-200 rounded-[10px] px-3.5 h-[35px] text-sm inline-flex items-center',
  pageBtnOn:      'cursor-pointer text-gray-900 hover:bg-gray-50',
  pageBtnOff:     'cursor-default text-gray-300',

}

export default Style;
